import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { AnalyticsApiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';


@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class AnalyticsApiModule {
    public static forRoot(configurationFactory: () => AnalyticsApiConfiguration): ModuleWithProviders<AnalyticsApiModule> {
        return {
            ngModule: AnalyticsApiModule,
            providers: [ { provide: AnalyticsApiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: AnalyticsApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('AnalyticsApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
